import React, { useEffect, useRef, useState } from 'react'
import { View } from 'react-native'

import { SH1 } from '@zet/design-system'
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated'

const NUMBERS = Array(10)
  .fill()
  .map((_, i) => i)

const usePrevious = (value?: string) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })

  if (typeof ref.current === 'undefined') {
    return '0'
  }

  return ref.current
}
type AnimatedNumberProps = {
  animateToNumber?: string
  animationDuration?: number
  easing?: any
  isVisibleAmount?: boolean
}

const NumberAnimation = ({
  value,
  numberHeight,
  animationDuration,
}: {
  value: string
  numberHeight: number
  animationDuration: number
}) => {
  const animation = useSharedValue(Number(value))

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateY: Number(-1 * (numberHeight * animation.value)),
        },
      ],
    }
  }, [animation, numberHeight])

  useEffect(() => {
    animation.value = withTiming(Number(value), {
      duration: animationDuration ?? 600,
    })
  }, [value])

  return (
    <View style={{ height: numberHeight, overflow: 'hidden' }}>
      <Animated.View style={[animatedStyle]}>
        {NUMBERS.map((number, i) => (
          <View style={{ flexDirection: 'row' }} key={i}>
            <SH1 style={{ height: numberHeight }}>{number}</SH1>
          </View>
        ))}
      </Animated.View>
    </View>
  )
}

const AnimatedNumber = ({
  animateToNumber,
  animationDuration,
  easing,
  isVisibleAmount = true,
}: AnimatedNumberProps) => {
  const animateToNumbersArr = animateToNumber?.split('') || []
  const [numberHeight, setNumberHeight] = useState(0)

  const setButtonLayout = (e: any) => {
    setNumberHeight(e.nativeEvent.layout.height)
  }

  if (!isVisibleAmount) {
    return <SH1>XXXX</SH1>
  }

  return (
    <>
      {numberHeight !== 0 && (
        <View style={{ flexDirection: 'row' }}>
          {animateToNumbersArr.map((n, index) => {
            if (isNaN(Number(n))) {
              return (
                <SH1 key={index} style={{ height: numberHeight }}>
                  {n}
                </SH1>
              )
            }
            return (
              <NumberAnimation
                numberHeight={numberHeight}
                value={n}
                animationDuration={animationDuration}
              />
            )
          })}
        </View>
      )}
      <SH1
        style={{ position: 'absolute', top: -999999 }}
        onLayout={setButtonLayout}
      >
        {0}
      </SH1>
    </>
  )
}

export { AnimatedNumber }
